// @flow

import React from 'react';
import type { ResultItemContainerProps } from '../../../utils/types';
import DefaultItem from '../DefaultItem';

const ResultItemContainer = (props: ResultItemContainerProps) => {
  return (
    <>
      <DefaultItem {...props} />
    </>
  );
};

export default ResultItemContainer;
